export const PENDING_COMMENTS = 'pending';
export const ALL_COMMENTS = 'all';
